module.exports = __webpack_public_path__ + "static/img/special-offer.432b404.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index-ads/special-offer.png
// module id = 1398
// module chunks = 1